module.exports = __webpack_public_path__ + "media/base/teammember_medium-d0e446ef.svg";